export default function getNumberWithCountryCode(userName) {
  // eslint-disable-next-line no-restricted-globals
  if (userName.includes('@') || isNaN(userName)) {
    return userName
  }

  // standard indian 10 digit mobile number
  if (userName.length === 10) return `+91${userName}`

  return userName
}
